module.exports = __webpack_public_path__ + "static/media/portfolio4.907570ad.jpg";